export default "__VITE_ASSET__DA6NCQ1y__"